<template>
    <b-overlay :show="drawingQuerying">
        <mini-table style="min-width: 400px"
                    :loading="drawingQuerying"
                    :items="materialDrawingInfo"
                    :fields="drawingTableFields"
                    disable-first-index-column
                    read-only row-click-check
                    enable-row-check
                    custom-columns="originFileName"
                    @rowChecked="checkedDrawingIds=$event">
            <template #leftHeader>
                <b-button variant="outline-primary" v-if="materialDrawingInfo.length>0"
                          :disabled="checkedDrawingIds.length===0"
                          @click="batchDownloadDrawing(checkedDrawingIds, currentMaterial)">
                    <i class="fa-solid fa-file-zipper"></i> 下载图纸
                </b-button>
            </template>
            <template #rightHeader>
                <b-form-checkbox v-model="withOld" name="check-button" switch
                                 @change="query">
                    包含旧图纸：<b>{{ withOld ? '是' : '否' }}</b>
                </b-form-checkbox>
            </template>
            <template #custom(originFileName)="{row, val}">
                <b-link @click="downloadDrawing(row.id, val)">{{ val }}</b-link>
            </template>
        </mini-table>
    </b-overlay>
</template>

<script>
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import drawingDownloadMixin from "@/views/sithMesII/pds/stuffs/drawing-download-mixin";

export default {
    name: "MaterialDrawingInfos",
    components: {MiniTable},
    mixins: [drawingDownloadMixin],
    props: {
        material: String
    },
    data() {
        return {
            materialDrawingInfo: [],
            drawingQuerying: false,
            drawingTableFields: [
                {key: 'originFileName', label: '文件名'},
                {key: 'number', label: '图纸号'},
                {key: 'version', label: '版本号'},
                {key: 'description', label: '描述'},
            ],
            withOld: false,
            currentMaterial: null,
            checkedDrawingIds: [],
            downloadLoading: false
        }
    },
    watch: {
        material: {
            handler() {
                this.currentMaterial = this.material;
                this.query();
            },
            immediate: true
        }
    },
    methods: {
        queryWithCheck(material) {
            if (this.currentMaterial !== material || this.materialDrawingInfo.length === 0) {
                this.currentMaterial = material;
                this.query();
            } else {
                this.$emit('got');
            }
        },
        query() {
            this.queryMaterialDrawingInfo(this.currentMaterial, this.withOld);
        },
        queryMaterialDrawingInfo(material, withOld = false) {
            if (material) {
                this.drawingQuerying = true;
                this.$store.dispatch('api/get', {
                    url: process.env.VUE_APP_SITHMESII_PDS_URL + "/sithMomMaterialDrawingInfo/drawing/info?material=" + material + "&withOld=" + withOld,
                    commonErrorHandle: false
                }).then(response => {
                    if (response && response.length > 0) {
                        this.materialDrawingInfo = response;
                        this.checkedDrawingIds = [];
                        this.$emit("got");
                    } else {
                        this.$emit("none");
                        this.$message.info("没有查询到图纸");
                    }
                }).finally(() => this.drawingQuerying = false);
            }
        },

    }
}
</script>

<style scoped>

</style>
